<template>
  <div :class="className">
    <h4>{{ $t('commons.connection.sign-up.title') }}</h4>
    <h5>{{ $t('commons.connection.sign-up.sub-title') }}</h5>
    <b>{{ $t('commons.connection.sign-up.copy') }}</b>
    <ul>
      <li
        v-for="(item, index) in $t('commons.connection.sign-up.list')"
        :key="index"
      >
        {{ item }}
      </li>
    </ul>
    <rent-button
      @buttonclicked="goToSignUp"
      grey
    >
      {{ $t('commons.connection.sign-up.sign-up') }}
    </rent-button>
  </div>
</template>

<script>
import RentButton from './RentButton'

export default {
  components: {
    RentButton,
  },
  props: {
    className: {
      type: String,
      required: true,
    },
    signupType: {
      type: String,
      default: null,
    },
  },
  methods: {
    goToSignUp() {
      if (this.signupType) {
        this.$store.commit('registration/SET_SIGN_UP_ORIGIN', this.signupType)
      }
      window.location.href = '/inscription/particulier'
    },
  },
}
</script>
